<nz-page-header class="large p-r-0">
  <nz-page-header-title>{{'job-offer.create-page.title' | translate}}</nz-page-header-title>
  <nz-page-header-extra>
    <nz-space>
      <button *nzSpaceItem nz-button nzType="primary" (click)="navigateToJOListPage()">< {{'job-offer.back-to-list.button' | translate}}</button>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>

<mh-mp-job-offer-form [jobOffer]="jobOffer" [isMobile]="(isMobileView$ | async)" (formChange)="onFormChange($event)"></mh-mp-job-offer-form>

<div nz-row [nzGutter]="24">
  <div nz-col [nzSpan]="24" class="form-footer-buttons">
    <nz-space>
      <button *nzSpaceItem nz-button (click)="navigateToJOListPage()">{{'cancel.button' | translate}}</button>
      <button *nzSpaceItem nz-button [nzType]="'primary'" (click)="onCreate()" [disabled]="!(hasReviewedStatus$ | async)"
              [nzLoading]="isSaving"
      >{{'save.button' | translate}}</button>
    </nz-space>
  </div>
</div>
